import {ListSidebar} from '@github-ui/repos-list'
import type {SidebarLink} from '@github-ui/saved-views'

import type {TypeFilter} from '../types'

interface OrgSidebarProps {
  onQueryChanged: (query: string) => void
  type: string
  types: TypeFilter[]
}

const phraseByType: Record<string, string> = {
  all: '',
  public: 'visibility:public archived:false',
  internal: 'visibility:internal archived:false',
  private: 'visibility:private archived:false',
  source: 'mirror:false fork:false archived:false',
  fork: 'fork:true archived:false',
  template: 'template:true archived:false',
  archived: 'archived:true',
  contributed: 'contributed-by:@me',
  adminable: 'admin:@me',
}

const iconByType: Record<string, SidebarLink['icon']> = {
  all: 'home',
  public: 'repo',
  internal: 'organization',
  private: 'repo_locked',
  source: 'link',
  fork: 'repo_forked',
  template: 'repo_template',
  archived: 'archive',
  contributed: 'people',
  adminable: 'gear',
}

const finderTypeFilters: TypeFilter[] = [
  {id: 'contributed', text: 'Contributed by me'},
  {id: 'adminable', text: 'Admin access'},
]

export function getOrderedTypes(types: TypeFilter[], includeFinderFilters: boolean): TypeFilter[] {
  if (!includeFinderFilters) return types

  const [allType, ...otherTypes] = types
  return [allType as TypeFilter, ...finderTypeFilters, ...otherTypes]
}

export function OrgSidebar({onQueryChanged, type, types}: OrgSidebarProps) {
  return (
    <ListSidebar
      links={getOrgLinks(types)}
      selectedLink={type}
      onSelectLink={link => onQueryChanged(link.query)}
      useCollapsibleLayout
    />
  )
}

export function getTypeFromQuery(query: string, types: TypeFilter[]) {
  return types.find(({id}) => phraseByType[id] === query.trim())?.id || ''
}

function getOrgLinks(types: TypeFilter[]): SidebarLink[] {
  return types.map(({id, text}) => ({
    id,
    name: text,
    searchType: 'repositories',
    query: getQueryFromType(id),
    icon: iconByType[id] || 'link',
    color: 'gray',
    source: 'predefined',
  }))
}

function getQueryFromType(type: string) {
  return phraseByType[type] || ''
}
